import React, { useState } from "react";
import { Gift } from "lucide-react";
import PageHeader from "../../components/PageHeader";
import Tabs from "../../components/Tabs";
import ReferralCategoriesTab from "./referral/ReferralCategoriesTab";
import ReferralVendorsTab from "./referral/ReferralVendorsTab";

const TABS = [
  { key: "categories", label: "Categories" },
  { key: "vendors", label: "Reward Partners" },
];

const ReferralVendors = () => {
  const [activeTab, setActiveTab] = useState("categories");

  return (
    <div className="p-6 lg:p-8 flex flex-col gap-6 min-h-[calc(100vh-4rem)]">
      <PageHeader
        icon={Gift}
        title="Referral Reward Partners"
        subtitle="Manage the reward categories and partner vendors where buyers redeem referral rewards"
      />

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
        <Tabs tabs={TABS} active={activeTab} onChange={setActiveTab} />
        <div className="p-5">
          {activeTab === "categories" && <ReferralCategoriesTab />}
          {activeTab === "vendors" && <ReferralVendorsTab />}
        </div>
      </div>
    </div>
  );
};

export default ReferralVendors;
